
import { Vue, Component, Watch } from 'vue-property-decorator';
import {
  Form,
  FormItem,
  Input,
  Cascader,
} from 'element-ui';
import { IPSearch } from '@/types/report.d';
import api from '@/api/question';

@Component({
  components: {
    Form,
    FormItem,
    Input,
    Cascader,
  },
})
export default class SearchForm extends Vue {
  private form: IPSearch = {
    userName: '',
    orgName: '',
    userLoginName: '',
  };

  public $refs!: {
    form: Form,
  };

  /**
   * @author liangyongmou
   * @description  接收普通搜索的值
   * @param { searchValue } 普通搜索的值
   */
  setTitle(searchValue: string) {
    this.form.userName = searchValue;
  }

  /**
   * @author liangyongmou
   * @desc 获取查询数据
   */
  getFormData() {
    return this.form;
  }

  /**
   * @author liangyongmou
   * @desc 清空事件
   */
  handleClear() {
    this.$refs.form.resetFields();
  }
}
